module.exports = __webpack_public_path__ + "36c4fc275ee6aebd0210003fa6e7529f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/news/img1_1.jpg
// module id = 279
// module chunks = 0